import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CalendarClock, Settings2, LayoutList, Link2, CalendarRange } from "lucide-react";
import AvailabilityTab from "@/pages/scheduling/AvailabilityTab";
import AppointmentTypesTab from "@/pages/scheduling/AppointmentTypesTab";
import BookingRulesTab from "@/pages/scheduling/BookingRulesTab";
import BookingsDashboard from "@/pages/scheduling/BookingsDashboard";
import BookingLinksTab from "@/pages/scheduling/BookingLinksTab";

const TABS = [
  { key: "bookings",     label: "Bookings",          icon: LayoutList,     Comp: BookingsDashboard,   testid: "sched-tab-bookings" },
  { key: "types",        label: "Appointment Types", icon: CalendarClock,  Comp: AppointmentTypesTab, testid: "sched-tab-types" },
  { key: "availability", label: "Availability",      icon: CalendarRange,  Comp: AvailabilityTab,     testid: "sched-tab-availability" },
  { key: "rules",        label: "Booking Rules",     icon: Settings2,      Comp: BookingRulesTab,     testid: "sched-tab-rules" },
  { key: "links",        label: "Booking Links",     icon: Link2,          Comp: BookingLinksTab,     testid: "sched-tab-links" },
];

// Backwards-compat aliases for existing deep links (?tab=weekly / overrides).
const TAB_ALIAS = { weekly: "availability", overrides: "availability" };

export default function Scheduling() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab") || "bookings";
  const active = TAB_ALIAS[raw] || raw;
  const setTab = (k) => setParams((p) => { const q = new URLSearchParams(p); q.set("tab", k); return q; });
  const [firstMount] = useState(() => active);
  const Comp = (TABS.find((t) => t.key === active) || TABS[0]).Comp;

  return (
    <div className="space-y-6 animate-fade-in-up" data-testid="scheduling-page">
      <div>
        <h1 className="font-display font-bold text-3xl tracking-tight text-[#1C1917]">Scheduling</h1>
        <p className="text-sm text-[#57534E] mt-1">Manage client appointments, availability, and booking rules.</p>
      </div>
      <div className="border-b border-[#E8E2D9] overflow-x-auto">
        <div className="flex gap-1 min-w-max">
          {TABS.map((t) => {
            const isActive = t.key === active;
            const Icon = t.icon;
            return (
              <button key={t.key} data-testid={t.testid} onClick={() => setTab(t.key)}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                  isActive ? "border-[#E8712C] text-[#1C1917]" : "border-transparent text-[#57534E] hover:text-[#1C1917]"}`}>
                <Icon size={15} strokeWidth={1.5} />
                {t.label}
              </button>
            );
          })}
        </div>
      </div>
      <Comp key={firstMount === active ? active : active} />
    </div>
  );
}
